import { render } from "./Landing.vue?vue&type=template&id=0c612406&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=0c612406&lang=scss&scoped=true"

import exportComponent from "/Users/richardpitul/Projects/booking-calendars/athletics-booking-calendar/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c612406"]])

export default __exports__